import React from "react";
import SignUpForm from "../../../components/auth-forms/signup/SignUpForm";

const SignUpPage = () => {
  return <SignUpForm></SignUpForm>;
};

export default SignUpPage;
